import { z } from "zod";

export const baseSchema = z.object({
  streetAddress: z.string().trim().min(1, { message: "Street Address cannot be empty" }),
  city: z.string().trim().min(1, { message: "City cannot be empty" }),
  province: z.string().trim().min(1, { message: "Province cannot be empty" }),
  postalCode: z.string().trim().min(1, { message: "Postal Code cannot be empty" }),
  ttandEmail: z.string().trim().email({ message: "Ttand Email cannot be empty" }),
  businessPhone: z
    .string()
    .transform((val) => val.replace(/[()\-\s]/g, ""))
    .refine((val) => /^\+?[\d()\-\s]+$/.test(val), {
      message: "Invalid phone number format",
    })
    .refine(
      (val) => {
        return val.length === 10;
      },
      {
        message: "Phone number must be exactly 10 digits",
      },
    ),
  brandedAs: z.string().trim().min(1, { message: "Agency Name cannot be empty" }),
  clientlinqBranch: z
    .string()
    .trim()
    .regex(/^\d+$/, { message: "Clientlinq Branch must contain only numbers" })
    .min(2, { message: "Clientlinq Branch must be at least 2 digits long" }),
});

export const updateAgencySchema = baseSchema.extend({
  status: z.boolean(),
});
export type UpdateAgencyFormType = z.infer<typeof updateAgencySchema>;

export const createAgencySchema = baseSchema.extend({
  firstname: z.string().trim().min(1, { message: "First Name cannot be empty" }),
  lastname: z.string().trim().min(1, { message: "Last Name cannot be empty" }),
  agentId: z.string().trim().regex(/^\d+$/, { message: "Agency ID must contain only numbers" }),
});
export type CreateAgencyFormType = z.infer<typeof createAgencySchema>;

export const updateAgentSchema = baseSchema.extend({
  firstname: z.string().trim().min(1, { message: "First Name cannot be empty" }),
  lastname: z.string().trim().min(1, { message: "Last Name cannot be empty" }),
  agentId: z.string().trim().regex(/^\d+$/, { message: "Agency ID must contain only numbers" }),
  agentType: z.string().trim().min(1, { message: "Agent Type must be selected" }),
  status: z.boolean(),
});
export type UpdateAgentFormType = z.infer<typeof updateAgentSchema>;

export const createAgentSchema = baseSchema.extend({
  firstname: z.string().trim().min(1, { message: "First Name cannot be empty" }),
  lastname: z.string().trim().min(1, { message: "Last Name cannot be empty" }),
  agentId: z.string().trim().regex(/^\d+$/, { message: "Agency ID must contain only numbers" }),
});

export type CreateAgentFormType = z.infer<typeof createAgentSchema>;
